export default "__VITE_ASSET__CRExF2wY__"